export const TAB_NAVIGATION_ACTIVATED_EVENT = 'tab-navigation-activated';
